import React, { Component, Suspense, useEffect } from "react";
import { Route, Router, Redirect } from "react-router-dom";
import Routers from "./routes";
import * as Layout from "../layout";
import { history } from "../helpers";
import CodeSplitter from "helpers/CodeSplitter";
import { NotificationContainer } from "react-notifications";
import Loader from "component/common/Loader";
import { restrictionURL } from "action/home";
import { connect } from "react-redux";
import MobileReponseShow from "pages/Dashboard/DashboardScreen/MobileReponseShow";
import MobileDetect from "mobile-detect";
var mobile = require("is-mobile");

function Wrapper({ Component, ...props }) {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  return <Component {...props} />;
}

class RoutesClass extends Component {
  constructor(props) {
    super(props);
    this.state = {
      renderRoute: false,
      pathname: null,
      loading: true,
      isMobile: false,
    };
  }

  fetchData = async () => {
    const { restrict } = this.props;
    await restrict();
  };

  componentWillMount() {
    this.fetchData();
  }

  componentDidMount() {
    // let temp = false;
    // temp = this.detectMob();
    // this.setState({
    //   isMobile: temp,
    // });
  }

  detectMob() {
    let hasTouchScreen = false;
    if ("maxTouchPoints" in navigator) {
      hasTouchScreen = navigator.maxTouchPoints > 0;
    } else if ("msMaxTouchPoints" in navigator) {
      hasTouchScreen = navigator.msMaxTouchPoints > 0;
    } else {
      const mQ = window.matchMedia && matchMedia("(pointer:coarse)");
      if (mQ && mQ.media === "(pointer:coarse)") {
        hasTouchScreen = !!mQ.matches;
      } else if ("orientation" in window) {
        hasTouchScreen = true; // deprecated, but good fallback
      } else {
        // Only as a last resort, fall back to user agent sniffing
        var UA = navigator.userAgent;
        hasTouchScreen =
          /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
          /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA);
      }
    }
    if (hasTouchScreen) {
      return true;
    } else {
      return false;
    }
    // alert(navigator.platform);
    // var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    // if (
    //   /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone/i.test(
    //     navigator.userAgent
    //   )
    // ) {
    //   alert("mobile");
    // } else {
    //   alert("Desktop");
    // }
    // var md = new MobileDetect(window.navigator.userAgent);
    // alert(JSON.stringify(md.phone()));
    // let isMobile = window.matchMedia(
    //   "only screen and (max-width: 480px)"
    // ).matches;
    // alert(isMobile ? "mobile" : "web");
    // var isChromeOrSafari =
    //   /Chrome|Safari/i.test(navigator.userAgent) &&
    //   /Mobile|Tablet/i.test(navigator.userAgent);
    // alert(
    //   JSON.stringify({
    //     width: window.innerWidth,
    //     height: window.innerHeight,
    //     pixel: window.devicePixelRatio,
    //   })
    // );
    // if (isMobile || window.innerWidth <= 400 || window.innerHeight <= 400) {
    //   return true;
    // }
    // if (isMobile && !isChromeOrSafari) {
    //   alert("This website is not supported on mobile devices.");
    // } else if (isChromeOrSafari) {
    //   alert("This website is not supported on this browser.");
    // }
    // let details = navigator.userAgent;
    // var isMobile = /iPhone|iPad|iPod|Android/i.test(details);
    // var isDesktopMode =
    //   /Mobile Safari|Android/.test(details) && /Version\//.test(details);
    // var isChrome = /Chrome/.test(details);
    // var isDesktop = window.innerWidth >= 1024;
    // const toMatch = [
    //   /Android/i,
    //   /webOS/i,
    //   /iPhone/i,
    //   /iPad/i,
    //   /iPod/i,
    //   /BlackBerry/i,
    //   /Windows Phone/i,
    // ];
    // alert(
    //   JSON.stringify({
    //     isMobile,
    //     isDesktopMode: isDesktopMode,
    //     isChrome,
    //     isDesktop,
    //   })
    // );
    // if (isMobile || !isDesktopMode || (isChrome && isDesktop)) {
    // }
    // let isMobileDevice = regexp.test(details);
    // return isMobileDevice;
  }

  render() {
    return (
      <>
          <Router history={history}>
            <Suspense fallback={<Loader />}>
              {Routers.map(
                ({
                  component,
                  name,
                  componentPath = "",
                  redirect,
                  path,
                  exact = false,
                  auth = true,
                  childrens = [],
                }) => {
                  if (childrens.length > 0) {
                    return (
                      <Route
                        path={path}
                        exact={exact}
                        key={path}
                        render={(props) => {
                          if (redirect) {
                            if (props.location.pathname == path) {
                              props.history.push(redirect);
                            }
                          }

                          const LayoutComponent = Layout[component];

                          return (
                            <LayoutComponent {...props}>
                              {childrens.map(
                                ({
                                  component: ChildrenComponent,
                                  componentPath: childComponentPath,
                                  name = "",
                                  path: childrenPath,
                                  exact = false,
                                  auth = true,
                                }) => {
                                  CodeSplitter.addComponent(
                                    childComponentPath,
                                    name
                                  );

                                  return (
                                    <Route
                                      path={path + childrenPath}
                                      exact={exact}
                                      key={path + childrenPath}
                                      render={(props) => {
                                        let PageComponent =
                                          CodeSplitter.getComponent(name);

                                        return (
                                          <Wrapper
                                            {...props}
                                            Component={PageComponent}
                                          />
                                        );
                                      }}
                                    />
                                  );
                                }
                              )}
                            </LayoutComponent>
                          );
                        }}
                      />
                    );
                  }

                  CodeSplitter.addComponent(componentPath, name);

                  return (
                    <Route
                      path={path}
                      exact={exact}
                      key={component || 2322}
                      render={(props) => {
                        if (component) {
                          let PageComponent = CodeSplitter.getComponent(name);
                          return (
                            <Wrapper {...props} Component={PageComponent} />
                          );
                        }

                        if (redirect) {
                          if (props.location.pathname == path) {
                            return <Redirect to={redirect} />;
                          }
                        }

                        return <div></div>;
                      }}
                    />
                  );
                }
              )}
              <NotificationContainer />
            </Suspense>
          </Router>
      </>
    );
  }
}

const mapState = (state) => ({});

const mapDispatch = {
  restrict: restrictionURL,
};

export default connect(mapState, mapDispatch)(RoutesClass);
